import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../layout/footer/footer'
import './payment-result.css'
import Beard from '../../assets/images/logo-beard2.svg'
import PenTool from '../../assets/icons/pen-tool.svg'
import GiftImg from '../../assets/images/gift-img2.svg'
import Accordion from 'react-bootstrap/Accordion';
import { BuyConfirm } from '../../utils/api'
import { useLocation } from "react-router-dom";


function PaymentResult() {
    const [id, setId] = useState(null)
    const [rrn, setRrn] = useState('')
    const [success, setSuccess] = useState('')
    const location = useLocation();
const sentPurchaseRef = useRef(false);

    // const [orderId , setOrderId] = useState('')
    const [message, setMessage] = useState(null)

    const buyConfirmFunc = async (chargeId) => {
        try {
            let res = await BuyConfirm({
                orderId: chargeId
            })
            setMessage(res.data)
            console.log('...', res)
        } catch (error) {

        }
    }
     useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const rrnParam = queryParams.get("rrn");
  const orderId = queryParams.get("orderId");
  const resParam = queryParams.get("res"); // "1" یا "0"

  setId(orderId);
  setSuccess(resParam);
  setRrn(rrnParam);

  // فقط اگر پرداخت موفق بود، ایونت purchase بفرست
  const isSuccess = (resParam === '1' || resParam === 1);

  if (
    isSuccess &&
    !sentPurchaseRef.current &&
    typeof window.gtag === 'function'
  ) {
    // 1) آیتم‌ها را از sessionStorage بخوان (قبل از پاک کردن)
    let storedItems = [];
    try {
      storedItems = JSON.parse(sessionStorage.getItem('cartItems') || '[]');
    } catch (e) {
      storedItems = [];
    }

    // 2) مپ ایمن برای GA4
    const gaItems = (storedItems || []).map((it) => ({
      item_id: String(it.id ?? it.productId ?? it.cardId ?? it.code ?? 'unknown'),
      item_name: it.title ?? it.name ?? 'Gift Card',
      item_category: it.categotyTitle ?? it.categoryTitle ?? '',
      price: Number(it.price) || 0,      // تومان
      quantity: Number(it.count) || 1,
    }));

    // 3) مجموع ارزش سفارش (کالاها) — اگر خواستی مالیات/ارسال را هم اضافه می‌کنیم
    const value = gaItems.reduce((sum, i) => sum + (i.price * i.quantity), 0);

    // 4) ارسال purchase
    window.gtag('event', 'purchase', {
      transaction_id: String(orderId || rrnParam || Date.now()),
      value,
      currency: 'IRT',     // تومان (نه IRR)
      items: gaItems,
      // اگر عددها را داری می‌تونی اضافه کنی:
      // tax: Number(taxAmount) || 0,
      // shipping: Number(deliveryPrice) || 0,
      debug_mode: true,    // برای DebugView (بعداً می‌تونی برداری)
    });

    sentPurchaseRef.current = true;

    // 5) بعد از ارسال، سبد را پاک کن
    sessionStorage.removeItem('cartItems');
  }
}, [location.search]);

        
    return (
        <div>
            <div className='container peyment-body'>
                <div className='d-flex align-items-center title gap-3'><img src={Beard} alt="" />نتیجه پرداخت</div>
                <div className='row mt-2 shop-cart gy-5'>
                    {id &&
                        <div className='col-12'>

                            {success == 1 || success == '1' ? (
                                <div className="bg-[#fff] rounded-lg p-5 flex flex-col justify-center align-items-center">
                                    <div className="my-3 rounded-full w-10 h-10 bg-[#00af0f]"></div>
                                    <div className="font-bold text-center">
                                        <h2 className='text-blue mt-3'>
                                            پرداخت با موفقیت انجام شد.
                                        </h2>
                                        <div className='mt-3'>
                                            شماره سفارش: {id}
                                        </div>
                                        <div className='mt-4'>
                                            جزییات پرداخت 
                                        </div>
                                        <div className='mt-2'>
                                            شماره پیگیری: {rrn}
                                        </div>
                                        {/* <div>
                                            تاریخ: ۲۶ مرداد ۱۴۰۳
                                        </div> */}
                                        <button className='btn btn-primary mt-4 mx-auto' type='button'>پیگیری سفارش</button>
                                    </div>
                                </div>
                            ) : (
                                <div className="mt-5 bg-[#fff] rounded-lg p-5 flex flex-col justify-center align-items-center">
                                    <div className="font-bold text-center">
                                        <h2 className='text-blue mt-3'>
                                            متاسفانه پرداخت شما ناموفق بود!
                                        </h2>
                                        <div className='mt-3'>
                                            شماره سفارش: {id}
                                        </div>
                                        <div className='mt-4'>
                                            جزییات پرداخت
                                        </div>
                                        <div className='mt-2'>
                                            شماره پیگیری: {rrn}
                                        </div>
                                        {/* <div>
                                            تاریخ: ۲۶ مرداد ۱۴۰۳
                                        </div> */}

                                        {/* <div className="text-[#686868] mt-3 font-normal">{message.message}</div> */}
                                        {/* <div className="flex justify-center gap-1 mt-4">
                                            <button className='btn btn-outline-primary' type='button'>تغییر روش پرداخت</button>
                                            <button className='btn btn-primary' type='button'>پرداخت مجدد</button>
                                        </div> */}
                                    </div>
                                </div>
                            )

                            }


                        </div>
                    }

                </div>
            </div>

            <div className="home-footer mt-40">
                <Footer />
            </div>
        </div>

    )
}

export default PaymentResult